import { useEffect } from "react";
// import { getLastChatUsers } from "../../../../Managers/Chat";
import styles from "../../index.module.scss";
import { NameAvatar } from "../../../nameImage";


export const ChatConnections = ({
  userList,
  showMoreBtn,
  handleClick,
  listComplete,
  showLess,
  showMoreStatus,
  notificationUser,
  notificationData,
  onlineUsers,
}) => {
  useEffect(() => {}, []);

  return (
    <div className={styles.ChatConnections}>
      <div className={styles.ChatConnections__title}>
        <h2>Connections</h2>
      </div>
      {userList.length > 0 &&
        userList.map((user, index) => {
          return (
            <div
              className={styles.ChatConnections__user}
              key={index}
              style={{ cursor: "pointer" }}
              onClick={() => handleClick(user)}
            >
              <div
                className={`${styles.ChatConnections__user__img} ${
                  onlineUsers.includes(user.id)
                    ? styles.ChatConnections__user__img_online
                    : ""
                }`}
              >
                {user.chatUserPhoto ? (
                  <img
                    src={user.chatUserPhoto}
                    alt="user"
                  />
                ) : (
                  <NameAvatar
                    firstName={
                      user.chatWithName ? user.chatWithName.split(" ")[0] : null
                    }
                    lastName={
                      user.chatWithName ? user.chatWithName.split(" ")[1] : ""
                    }
                    width={"3.125rem"}
                    height={"3.125rem"}
                    size={"1rem"}
                  />
                )}
              </div>
              <div className={styles.ChatConnections__user__name}>
                <h3>
                  {user[user.chatWith]
                    ? user[user.chatWith]
                    : user.chatWithName}
                </h3>

                {notificationUser && notificationUser.includes(user.id) ? (
                  <div
                    className={
                      styles.userListBox__userList_user_Connect_container
                    }
                  >
                    {notificationData &&
                      notificationUser &&
                      notificationData[user.id]?.count && (
                        <button>{notificationData[user.id]?.count}</button>
                      )}
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          );
        })}
      <div className={styles.ChatConnections__user__showMore}>
        {!showMoreStatus ? (
          !listComplete ? (
            <button onClick={() => showMoreBtn()}>show more</button>
          ) : (
            <button onClick={() => showLess()}>show less</button>
          )
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
